import {
  SET_BANNERS,
  ADD_BANNER_IMAGE_ITEM,
  UPDATE_BANNER_IMAGE_ITEM,
  UPDATE_BANNER_IMAGE_ITEM_ERROR,
  UPDATE_BANNER_ITEM,
  INIT_BANNERS,
  CREATE_BANNER_ITEM,
  ADD_BANNER_IMAGE_ITEM_ERROR,
} from '../constants/actions'
import { uploadMainImage } from '../modules/portal-remote/portalImageService'

export const initBanners = () => {
  return { type: INIT_BANNERS }
}

export const setBanners = banners => {
  return { type: SET_BANNERS, banners }
}

export const updateBanner = banner => {
  return { type: UPDATE_BANNER_ITEM, banner }
}

export const createBanner = banner => {
  return { type: CREATE_BANNER_ITEM, banner }
}

export const removeBannerImage = mainImageId => {
  return { type: ADD_BANNER_IMAGE_ITEM, mainImageId }
}

export const addBannerImage = (bannerID, imageFile) => async dispatch => {
  try {
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadMainImage(imageFile)
    dispatch({
      type: UPDATE_BANNER_IMAGE_ITEM,
      bannerID,
      mainImageId,
      mainImageLastChecked,
    })
  } catch ({ message }) {
    dispatch({ type: ADD_BANNER_IMAGE_ITEM_ERROR, message })
  }
}

export const updateBannerImage = (
  bannerID,
  imageFile,
  repalceImageID,
  originalImageID,
) => async dispatch => {
  try {
    const {
      ref: mainImageId,
      lastChecked: mainImageLastChecked,
    } = await uploadMainImage(imageFile, repalceImageID, originalImageID)
    dispatch({
      type: UPDATE_BANNER_IMAGE_ITEM,
      bannerID,
      mainImageId,
      mainImageLastChecked,
    })
  } catch ({ message }) {
    dispatch({ type: UPDATE_BANNER_IMAGE_ITEM_ERROR, message })
  }
}



// WEBPACK FOOTER //
// ./src/actions/banners.js